import { FeedbackRapport } from '../components/FeedbackRapport';
import { useGekozenWeek } from '../hooks/useGekozenWeek';

const EIGEN = { soort: 'eigen' } as const;

/**
 * Eigen werk — "Mijn feedback" (S3 en S4, SPEC-werkkwaliteit-herontwerp story 9).
 *
 * Een dunne pagina rond `FeedbackRapport`: de week staat in het adres (`useGekozenWeek`), de rest is het
 * rapport. De pagina vraagt alleen de eigen week op, met de week als enige argument: nooit een
 * medewerker-id.
 */
export function OwnWorkPage() {
  const { week, weken, kies } = useGekozenWeek();
  return (
    <div className="flex min-w-0 flex-col gap-4" data-testid="werkkwaliteit-eigen-werk">
      <FeedbackRapport bron={EIGEN} onKiesWeek={kies} week={week} weken={weken} />
    </div>
  );
}
